module.exports = __webpack_public_path__ + "img/missing_image_product_card.142aa6fe.svg";